import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
    FileManagerComponent,
    Inject,
    NavigationPane,
    DetailsView,
    Toolbar,
} from "@syncfusion/ej2-react-filemanager";
import "@syncfusion/ej2-base/styles/material.css";

import { v4 as uuidv4 } from 'uuid';


import authHeader from "../config/authHeader";
import config from "../config/config";
import { useAuth } from '../contexts/AuthContext';

import DocumentUploadModal from "../components/DocumentUploadModal";

import CustomSelect from "../utils/CustomSelect";

import { useFileManager } from "../contexts/FileManagerContext";

import useFetchDoxExt from "../hooks/useFetchDoxExt";
import useFetchIntervenants from "../hooks/useFetchIntervenants";

import { L10n, setCulture } from "@syncfusion/ej2-base";
import fr from "@syncfusion/ej2-locale/src/fr.json";

L10n.load(fr);
setCulture("fr");

const FileManager = ({ lstDoxExt, setIsViewerVisible, setSelectedDocument, refreshDoxExt }) => {
    const { uuid } = useParams();

    const { getUserInfo } = useAuth();

    const [fileSystemData, setFileSystemData] = useState([]);
    const { currentFolder, setCurrentFolder, imageToEdit, setImageToEdit, noteToEdit, setNoteToEdit } = useFileManager();

    const { fetchBlobBase64ByUUID } = useFetchDoxExt();
    const { relIntervenants, fetchRelationsIntervenants, cas, fetchChargesAffairesByLicence } = useFetchIntervenants();

    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [emailData, setEmailData] = useState({
        subject: "",
        body: "",
        recipient: [],
        files: [],
    });

    const [errors, setErrors] = useState({});

    const editorRef = useRef(null);

    const validateForm = () => {
        let newErrors = {};

        if (!emailData.subject.trim()) {
            newErrors.subject = "Veuillez renseigner l'objet.";
        }
        if (!emailData.body.trim()) {
            newErrors.body = "Veuillez écrire un message.";
        }
        if (listIntervenantsSelected.every(dept => dept.subOptions.every(sub => !sub.selected))) {
            newErrors.recipients = "Veuillez sélectionner au moins un destinataire.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        fetchRelationsIntervenants();
    }, []);

    const [listIntervenantsSelected, setListIntervenantsSelected] = useState([]);
    const [showAllRelIntervenants, setShowAllRelIntervenants] = useState(false);
    const [IsCopyEmail, setIsCopyEmail] = useState(true);

    //pin relIntervenants
    useEffect(() => {
        // console.log("RELATIONS INTERVENANTS", relIntervenants.filter(intervenant => intervenant.UUID_Externe === uuid));

        let formattedRelIntOptions = [];

        let currentDepartment = null;
        let subOptions = [];
        let departmentId = 1;

        const filteredRelIntervenants = showAllRelIntervenants
            ? relIntervenants
            : relIntervenants.filter(intervenant => intervenant.UUID_Externe === uuid);

        filteredRelIntervenants.forEach(intervenant => {
            if (currentDepartment !== intervenant.Intervenant) {
                if (currentDepartment !== null) {
                    formattedRelIntOptions.push({
                        id: departmentId,
                        label: `${currentDepartment} (${intervenant.Intervenant_Type})`,
                        subOptions: subOptions
                    });
                    departmentId++;
                }

                currentDepartment = intervenant.Intervenant;
                subOptions = [];
            }

            subOptions.push({
                id: intervenant.UUID_,
                label: `${intervenant.Nom} <${intervenant.Email}> (${intervenant.Intervenant})`,
                selected: false
            });
        });

        if (currentDepartment !== null) {
            formattedRelIntOptions.push({
                id: departmentId,
                label: currentDepartment,
                subOptions: subOptions
            });
        }

        setListIntervenantsSelected(formattedRelIntOptions);
        // console.log("formattedRelIntOptions", formattedRelIntOptions);
    }, [relIntervenants, showAllRelIntervenants]);

    const handleRelIntSelectionChange = (id) => {
        setListIntervenantsSelected((prevList) => {
            return prevList.map((department) => {
                if (department.subOptions) {
                    const updatedSubOptions = department.subOptions.map((subOption) => {
                        if (subOption.id === id) {
                            subOption.selected = !subOption.selected;
                        }
                        return subOption;
                    });

                    department.subOptions = updatedSubOptions;
                }
                return department;
            });
        });
    };


    useEffect(() => {
        const permission = {
            copy: true,
            download: true,
            write: true,
            writeContents: true,
            read: true,
            upload: true,
            message: "",
        };

        const createHierarchy = (docs) => {
            const folders = {};
            const files = [];

            const rootFolder = "Documents Externes";
            const idroot = uuidv4();
            folders[rootFolder] = {
                dateCreated: new Date(),
                dateModified: new Date(),
                filterPath: "",
                hasChild: true,
                id: idroot,
                isFile: false,
                name: rootFolder,
                parentId: null,
                size: 0,
                type: "folder",
                permission: permission,
            };

            docs.forEach((doc) => {

                if (doc.UUID_Externe_ && doc.UUID_Externe_ !== uuid) {
                    return; // on ne affiche pas les PJ dans le FM
                }
                const pathParts = doc.Dossier.split("\\").filter(Boolean);
                let parentId = idroot;

                // Créer la hiérarchie des dossiers
                pathParts.forEach((part, index) => {
                    const currentPath = `${rootFolder}\\${pathParts.slice(0, index + 1).join("\\")}`;

                    if (!folders[currentPath]) {
                        const id = uuidv4();
                        folders[currentPath] = {
                            dateCreated: new Date(doc.Date_Crea || new Date()),
                            dateModified: new Date(doc.Date_Modif || new Date()),
                            filterPath: index > 0 ? pathParts.slice(0, index + 1).join("\\") : rootFolder,
                            hasChild: true,
                            id: id,
                            isFile: false,
                            name: part,
                            parentId: parentId,
                            size: 0,
                            type: "folder",
                            permission: permission,
                        };
                    }

                    parentId = folders[currentPath].id;
                });

                if (!doc.Nom_Du_Document.startsWith(".")) {
                    files.push({
                        dateCreated: new Date(doc.Date_Crea || new Date()),
                        dateModified: new Date(doc.Date_Modif || new Date()),
                        filterPath: pathParts.length > 0 ? pathParts.join("\\") : rootFolder,
                        hasChild: false,
                        id: doc.Id || uuidv4(),
                        isFile: true,
                        name: doc.Nom_Du_Document,
                        parentId: parentId,
                        size: doc.Taille || 0,
                        type: (doc.Type_Document || doc.Suffix || '').toUpperCase(),
                        permission: permission,
                        UUID_: doc.UUID_,
                    });
                }

            });

            docs.filter(ds => ds.Nom_Du_Document.startsWith(".ds")).forEach((ds) => {
                const nomfolder = ds.Nom_Du_Document.slice(4);

                Object.values(folders).forEach(folder => {
                    if (folder.name === nomfolder) {
                        folder.UUID_ = ds.UUID_;
                    }
                });
            });

            return [...Object.values(folders), ...files];
        };

        const formattedData = createHierarchy(lstDoxExt);
        setFileSystemData(formattedData);
    }, [lstDoxExt]);

    // console.log("DOXEXT", lstDoxExt);
    // console.log("FORMAT", fileSystemData);

    const handleFileOpen = (args) => {
        if (args.fileDetails.isFile) {
            args.cancel = true;
            console.log("Double clic sur un fichier :", args.fileDetails);
            setSelectedDocument(args.fileDetails);
            setIsViewerVisible(true);
        } else {
            let folder = args.fileDetails;
            let dossier = "";
            while (folder && folder.name !== "Documents Externes") {
                dossier = dossier + "\\" + folder.name;
                folder = fileSystemData.find(doc => doc.id === folder.parentId);
            }
            console.log("Double clic sur un dossier :", dossier, args);
            setCurrentFolder(dossier);
        }
    };

    const handleFileRemove = async (args) => {
        const files = args.itemData;

        let filesToDelete = [];
        let pathsToCheck = [];

        files.forEach((file) => {
            if (!file.isFile) {
                pathsToCheck.push(file.id);
            } else {
                filesToDelete.push(file);
            }
        });

        const collectFilesRecursively = (folderId) => {
            const children = fileSystemData.filter((doc) => doc.parentId === folderId);
            children.forEach((child) => {
                if (child.isFile) {
                    filesToDelete.push(child);
                } else {
                    pathsToCheck.push(child.id);
                    collectFilesRecursively(child.id);
                }
            });
        };

        pathsToCheck.forEach((pathId) => collectFilesRecursively(pathId));

        pathsToCheck.forEach((pathId) => {
            const folder = fileSystemData.find((doc) => doc.id === pathId);
            if (folder) {
                const dsFile = lstDoxExt.find(
                    (doc) => doc.Dossier.includes(folder.name) && doc.Nom_Du_Document === `.ds_${folder.name}`
                );
                if (dsFile) {
                    filesToDelete.push(dsFile);
                }
            }
        });

        console.log("Fichiers et dossiers à supprimer (récursivement):", filesToDelete);

        if (filesToDelete.length > 0) {
            try {
                const deletePromises = filesToDelete.map(async (file) => {
                    const formData = new FormData();
                    formData.append("uuid", file.UUID_);

                    const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_deleteDoxExt`, {
                        method: "POST",
                        headers: authHeader(),
                        body: formData,
                    });

                    const responseData = await response.json();

                    if (responseData.status !== "success") {
                        console.error(`Erreur de suppression pour ${file.name}:`, responseData.message);
                        args.cancel = true;
                    }
                });

                await Promise.all(deletePromises);

                console.log("Tous les fichiers et dossiers ont été supprimés.");
            } catch (error) {
                console.error("Erreur lors de la suppression :", error);
                args.cancel = true;
            }
        } else {
            console.log("Aucun fichier à supprimer.");
        }
    };

    const validateFileName = (name) => {
        const invalidChars = /[<>:"\/\\|?*]/;
        return !invalidChars.test(name) && name.trim() !== "";
    };

    const handleFileRename = async (args) => {
        console.log("Renommer le fichier/dossier :", args);
        const file = args.itemData[0];
        const oldName = file.name;
        const newName = args.newName;

        // Vérification de la validité du nouveau nom
        if (!validateFileName(newName)) {
            console.error("Nom de fichier/dossier invalide :", newName);
            args.cancel = true;
            return;
        }

        if (file.isFile) {
            // Cas 1 : Renommer un fichier
            try {
                const formData = new FormData();
                formData.append("uuid", file.UUID_);
                formData.append("rename", newName);

                const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_editDoxExt`, {
                    method: "POST",
                    headers: authHeader(),
                    body: formData,
                });

                const responseData = await response.json();

                if (responseData.status === "success") {
                    console.log(`Fichier renommé avec succès : ${oldName} -> ${newName}`);
                } else {
                    console.error(`Erreur lors du renommage du fichier : ${responseData}`);
                    args.cancel = true;
                }
            } catch (error) {
                console.error("Erreur lors du renommage du fichier :", file.UUID_, error);
                args.cancel = true;
            }
        } else {
            // Cas 2 : Renommer un dossier
            try {

                const children = fileSystemData.filter((doc) => doc.filterPath.includes(oldName));

                const updatePromises = children.map(async (child) => {
                    const childFormData = new FormData();
                    childFormData.append("uuid", child.UUID_);

                    const updatedPath = child.filterPath.replace(oldName, newName).replace(/Documents Externes/g, '');

                    childFormData.append("dossier", updatedPath);

                    const childResponse = await fetch(`${config.apiBaseUrl}/4DACTION/KST_editDoxExt`, {
                        method: "POST",
                        headers: authHeader(),
                        body: childFormData,
                    });

                    const childResponseData = await childResponse.json();

                    if (childResponseData.status !== "success") {
                        console.error(`Erreur lors du renommage d'un fichier enfant : ${child.UUID_}`);
                    }
                });

                const dsFile = lstDoxExt.find(
                    (doc) => doc.Dossier.includes(oldName) && doc.Nom_Du_Document === `.ds_${oldName}`
                );

                if (dsFile) {
                    const dsFormData = new FormData();
                    dsFormData.append("uuid", dsFile.UUID_);
                    dsFormData.append("rename", `.ds_${newName}`);
                    dsFormData.append("dossier", newName);

                    const dsResponse = await fetch(`${config.apiBaseUrl}/4DACTION/KST_editDoxExt`, {
                        method: "POST",
                        headers: authHeader(),
                        body: dsFormData,
                    });

                    const dsResponseData = await dsResponse.json();

                    if (dsResponseData.status !== "success") {
                        console.error(`Erreur lors du renommage du fichier .ds_ : ${dsFile.UUID_}`);
                    } else {
                        console.log(`Fichier .ds_ renommé avec succès : ${oldName} -> ${newName}`);
                    }
                }

                await Promise.all(updatePromises);

                console.log(`Dossier et ses enfants renommés avec succès : ${oldName} -> ${newName}`);
            } catch (error) {
                console.error("Erreur lors du renommage du dossier :", file.UUID_, error);
                args.cancel = true;
            }
        }
    };

    const moveFilesToDestination = async (files, destination, actionType) => {
        const isMoveAction = actionType === "move";

        console.log(`Action de ${isMoveAction ? "déplacement" : "copie"} de fichiers :`, files, "| Destination: ", destination);

        try {
            const updateFileLocation = async (file, newDestination) => {
                const formData = new FormData();
                formData.append("uuid", file.UUID_);

                if (newDestination === "Documents Externes" || newDestination === "") {
                    newDestination = "-";
                }

                formData.append("dossier", newDestination);

                console.log("Fichier à déplacer/copier :", file, "| Destination :", newDestination);

                const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_editDoxExt`, {
                    method: "POST",
                    headers: authHeader(),
                    body: formData,
                });

                const responseData = await response.json();

                if (responseData.status !== "success") {
                    console.error(`Erreur lors du déplacement/copier du fichier ${file.name}:`, responseData.message);
                } else {
                    console.log(`Fichier ${isMoveAction ? "déplacé" : "copié"} :`, file.name);
                }
            };

            const moveFolderContents = async (folder, currentPath) => {
                const newFolderPath = currentPath + "\\" + folder.name;

                await updateFileLocation(folder, newFolderPath);

                const children = fileSystemData.filter(doc => doc.parentId === folder.id);

                for (const child of children) {
                    if (child.isFile) {
                        await updateFileLocation(child, newFolderPath);
                    } else {
                        await moveFolderContents(child, newFolderPath);
                    }
                }
            };

            const movePromises = files.map(async (file) => {
                if (!file.isFile) {
                    await moveFolderContents(file, destination);
                } else {
                    await updateFileLocation(file, destination);
                }
            });

            await Promise.all(movePromises);
        } catch (error) {
            console.error("Erreur lors du traitement des fichiers :", error);
        }
    };

    const handleFilePasted = async (args) => {
        console.log("Action de coller détectée :", args);

        const files = args.itemData;
        let currentPath = args.targetData;
        let destination = "";

        while (currentPath && currentPath.name !== "Documents Externes") {
            destination = currentPath.name + "\\" + destination;
            currentPath = fileSystemData.find(doc => doc.id === currentPath.parentId);
        }

        if (args.name === "beforeMove") {
            await moveFilesToDestination(files, destination, "move");
        }
    };

    const handleFolderCreate = async (args) => {
        console.log("Création d'un nouveau dossier :", args);

        let folderParent = args.parentFolder[0];
        let folderPath = "\\" + args.folderName;

        while (folderParent && folderParent.name !== "Documents Externes") {
            folderPath = folderParent.name + "\\" + folderPath;
            folderParent = fileSystemData.find(doc => doc.id === folderParent.parentId);
        }

        const formData = new FormData();
        formData.append("title", `.ds_${args.folderName}`);
        formData.append("uuid", uuid);
        formData.append("type", "folder");
        formData.append("dossier", folderPath);

        const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_createDoxExt`, {
            method: "POST",
            headers: authHeader(),
            body: formData,
        });

        if (!response.ok) {
            console.error("Erreur lors de la création du dossier :", response.statusText);
        } else {
            console.log("Dossier créé avec succès :", args.folderName);
        }
    };

    const handleDownload = async (args) => {
        console.log("Download du fichier :", args);

        for (const selectedDocument of args.data.data) {
            const base64Content = await fetchBlobBase64ByUUID(selectedDocument.UUID_);

            if (!base64Content || !selectedDocument) return;

            const fileTypeMapping = {
                "PDF": "application/pdf",
                "JPEG": "image/jpeg",
                "PNG": "image/png",
                "WEBP": "image/webp",
                "SVG": "image/svg+xml",
                "TXT": "text/plain",
                "MSG": "application/vnd.ms-outlook",
                "XLSX": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "XLS": "application/vnd.ms-excel",
                "VND.MS-EXCEL": "application/vnd.ms-excel",
            };

            const normalizedType = selectedDocument.type.replace(/\s+/g, "").toUpperCase();
            const fileType = fileTypeMapping[normalizedType] || "application/octet-stream";
            let fileExtension = selectedDocument.type.toLowerCase().replace(/\s+/g, "");
            if (fileExtension === "vnd.ms-excel") fileExtension = "xls";
            if (fileExtension === "plain") fileExtension = "txt";
            const fileName = `${selectedDocument.name.split(".")[0] || 'document'}.${fileExtension}`;

            const fileBlob = new Blob(
                [new Uint8Array(atob(base64Content).split('').map(char => char.charCodeAt(0)))],
                { type: fileType }
            );

            if (window.showSaveFilePicker) {
                try {
                    const fileHandle = await window.showSaveFilePicker({
                        suggestedName: fileName,
                        types: [{ accept: { [fileType]: [`.${fileExtension}`] } }],
                    });

                    const writableStream = await fileHandle.createWritable();
                    await writableStream.write(fileBlob);
                    await writableStream.close();
                } catch (error) {
                    if (error.name !== "AbortError") {
                        console.error("Téléchargement annulé ou erreur :", error);
                    }
                }
            } else {
                const url = URL.createObjectURL(fileBlob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                URL.revokeObjectURL(url);
            }
        }

    };

    const handleOpenEmailPopup = async (args) => {
        const iconMapping = {
            "PDF": "e-fe-pdf",
            "JPEG": "e-fe-image",
            "PNG": "e-fe-image",
            "WEBP": "e-fe-image",
            "SVG": "e-fe-image",
            "TXT": "e-fe-txt",
            "PLAIN": "e-fe-txt",
            "MSG": "e-fe-msg",
            "XLSX": "e-fe-xlsx",
            "XLS": "e-fe-xls",
            "VND.MS-EXCEL": "e-fe-xls",
        };

        const formattedFiles = args.fileDetails.map((file) => ({
            name: `${file.name.length > 30 ? file.name.substring(0, 30) + '...' : file.name}`,
            type: file.type.replace(/\s+/g, "").toUpperCase(),
            UUID_: file.UUID_,
            icon: iconMapping[file.type.replace(/\s+/g, "").toUpperCase()] || "gray",
        }));
        console.log("Partager par Email :", formattedFiles);
        setEmailData((prevData) => ({
            ...prevData,
            files: formattedFiles,
        }));
        setIsEmailModalOpen(true);
    };

    const handleSendEmail = async () => {
        if (validateForm()) {
            setIsEmailModalOpen(false);
            const selectedFiles = {};
            emailData.files.forEach((file, index) => {
                selectedFiles[`fichier_${index + 1}`] = {
                    UUID: file.UUID_,
                    Nom: file.name,
                    Type: file.type,
                };
            });

            const selectedRecipients = {};
            let index = 0;
            listIntervenantsSelected.forEach((department) => {
                department.subOptions.forEach((subOption) => {
                    if (subOption.selected) {
                        selectedRecipients[`destinataire_${index}`] = {
                            UUID: subOption.id,
                            Nom: subOption.label.split(' <')[0],
                            Email: subOption.label.split('<')[1].split('>')[0]
                        };
                        index++;
                    }
                });
            });

            const userInfo = await getUserInfo()

            if (IsCopyEmail) {
                selectedRecipients[`CCi`] = {
                    UUID: userInfo.UUID,
                    Nom: userInfo.Nom,
                    Email: userInfo.Email,
                };
            }

            const bodyObject = {
                content: emailData.body,
            };

            const emailPayload = {
                user: userInfo,
                subject: emailData.subject,
                body: bodyObject,
                recipients: selectedRecipients,
                files: selectedFiles
            };

            setEmailData({
                subject: "",
                body: "",
                recipient: [],
                files: [],
            });
            console.log("Envoi de l'email...", emailPayload);

            const formData = new FormData();
            formData.append("emailPayload", JSON.stringify(emailPayload));

            try {
                const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_createEnvoiDoc`, {
                    method: 'POST',
                    headers: authHeader(),
                    body: formData,
                });
                if (!response.ok) {
                    throw new Error('Erreur réseau lors de la mise à jour du details interventions');
                }
                const data = await response.json();
            } catch (err) {
                console.error('Erreur lors de la création de l’envoi de document :', err);
            }
        }
    };

    const handleImageLoad = async (args) => {
        const file = args.fileDetails[0];
        const mimeType = file.type.toLowerCase();

        setTimeout(async () => {
            try {
                const base64img = await fetchBlobBase64ByUUID(file.UUID_);
                const imageUrl = `data:image/${mimeType};base64,${base64img}`;

                const imgElement = document.querySelector(`[data-uid="${file.id}"] img`);
                if (imgElement) {
                    imgElement.src = imageUrl;
                }
            } catch (error) {
                console.error("Erreur lors du chargement de l'image :", error);
            }
        }, 100);
    };

    const handleOpenAnnoteImage = async (args) => {
        const file = args.fileDetails[0];
        // console.log(file.type.toLowerCase());
        const mimeType = file.type.toLowerCase();

        if (!["jpg", "jpeg", "png", "webp"].some(type => mimeType.includes(type))) {
            return;
        }

        try {
            const base64img = await fetchBlobBase64ByUUID(file.UUID_);
            const imageUrl = `data:image/${mimeType};base64,${base64img}`;

            setTimeout(() => {
                setImageToEdit(imageUrl);
            }, 100);
        } catch (error) {
            console.error("Erreur lors du chargement de l'image :", error);
        }
    };

    const handleOpenModifNote = async (args) => {
        const file = args.fileDetails[0];
        const mimeType = file.type.toLowerCase();
        console.log("file", file);

        if (!["txt", "plain", "plain/text"].some(type => mimeType.includes(type))) {
            return;
        }

        try {
            const base64Content = await fetchBlobBase64ByUUID(file.UUID_);

            const byteCharacters = atob(base64Content);

            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
            }

            const decoder = new TextDecoder("utf-8");
            const decodedContent = decoder.decode(byteArray);

            const lines = decodedContent.split("\n");

            setTimeout(() => {
                setNoteToEdit({ UUID_: file.UUID_, title: file.name, type: mimeType, body: lines.join("\n") });
            }, 100);
        } catch (error) {
            console.error("Erreur lors du chargement de la note :", error);
        }
    }

    return (
        <>
            <div className="flex flex-col h-[calc(70vh-100px)] min-h-[400px] overflow-hidden">
                <div className="w-full h-full overflow-auto">
                    <FileManagerComponent
                        id="filemanager"
                        locale="fr"
                        className="min-h-[400px]"
                        height="100%"
                        allowDragAndDrop={true}
                        fileSystemData={fileSystemData}
                        toolbarSettings={{ items: ['NewFolder', 'Cut', 'Copy', 'Paste', 'Delete', 'Rename', 'SortBy', 'Refresh', 'Selection', 'View', 'Details', "Partager par Email", "Annoter l'Image", "Modifier la note"] }}
                        contextMenuSettings={{
                            file: ["Cut", "Copy", "|", "Delete", "Rename", "|", "Details", "|", "Partager par Email", "|", "Annoter l'Image", "|", "Modifier la note"],
                            folder: ["Open", "|", "Cut", "Copy", "Paste", "|", "Delete", "Rename", "|", "Details"],
                            layout: ["SortBy", "View", "Refresh", "|", "Paste", "|", "NewFolder", "|", "Details", "|", "SelectAll"],
                            visible: true
                        }}

                        fileOpen={(args) => handleFileOpen(args)}
                        beforeDelete={(args) => handleFileRemove(args)}
                        beforeRename={(args) => handleFileRename(args)}
                        beforeMove={(args) => handleFilePasted(args)}
                        beforeFolderCreate={(args) => handleFolderCreate(args)}
                        beforeDownload={(args) => { args.cancel = true; handleDownload(args) }}
                        beforeImageLoad={(args) => handleImageLoad(args)}
                        menuClick={(args) => {
                            if (args.item.text === "Partager par Email") {
                                handleOpenEmailPopup(args);
                            }
                            if (args.item.text === "Annoter l'Image") {
                                handleOpenAnnoteImage(args);
                            }
                            if (args.item.text === "Modifier la note") {
                                handleOpenModifNote(args);
                            }
                        }}
                        toolbarClick={(args) => {
                            if (args.item.properties.text === "Partager par Email") {
                                handleOpenEmailPopup(args);
                            }
                            if (args.item.properties.text === "Annoter l'Image") {
                                handleOpenAnnoteImage(args);
                            }
                            if (args.item.properties.text === "Modifier la note") {
                                handleOpenModifNote(args);
                            }
                        }}
                    >
                        <Inject services={[NavigationPane, DetailsView, Toolbar]} />
                    </FileManagerComponent>
                </div>
            </div>

            {/* <DocumentUploadModal isVisible={isDrawingOpen} onClose={handleCloseAnnoteImage} onUploadSuccess={refreshDoxExt} uniqueUpload={true}/> */}

            {isEmailModalOpen && (
                <div
                    className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50`}
                    onClick={(e) => {
                        const selection = window.getSelection();
                        if (selection && selection.type === "Range") {
                            return;
                        }
                        if (e.target === e.currentTarget) {
                            setIsEmailModalOpen(false);
                        }
                    }}
                >
                    <div className="z-10 bg-white p-10 rounded-xl w-full sm:max-w-4xl">
                        <div className="text-center">
                            <h2 className="mt-2 font-bold text-gray-900 text-3xl">Envoyer un Email</h2>
                            <p className="mt-2 text-gray-400 text-sm">Partager les fichiers sélectionnés par email.</p>
                        </div>

                        <form className="space-y-3 mt-5" onSubmit={(e) => e.preventDefault()}>
                            {/* Objet */}
                            <div>
                                <label className="block font-semibold text-gray-700">Objet</label>
                                <input
                                    type="text"
                                    name="subject"
                                    value={emailData.subject}
                                    onChange={(e) => setEmailData({ ...emailData, subject: e.target.value })}
                                    className={`mt-1 p-2 border ${errors.subject ? 'border-red-500' : 'border-gray-300'} rounded-md w-full`}
                                    placeholder="Objet de l'email"
                                />
                                {errors.subject && <p className="mt-1 text-red-500 text-sm">{errors.subject}</p>}
                            </div>

                            {/* Destinataire */}
                            <div>
                                <label className="block font-semibold text-gray-700">Destinataire</label>
                                <div className="flex justify-between items-center">
                                    <CustomSelect
                                        value={
                                            listIntervenantsSelected
                                                .flatMap(dept => dept.subOptions.filter(sub => sub.selected).map(sub => sub.label))
                                                .join(", ") || "Aucun Intervenants sélectionné"
                                        }
                                        options={listIntervenantsSelected}
                                        onChange={handleRelIntSelectionChange}
                                        isNested={true}
                                    />
                                    <label class="flex gap-2 min-w-36 mcui-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={showAllRelIntervenants}
                                            onChange={() => setShowAllRelIntervenants(!showAllRelIntervenants)}
                                        />
                                        <div>
                                            <svg class="mcui-check" viewBox="-2 -2 35 35" aria-hidden="true">
                                                <polyline points="7.57 15.87 12.62 21.07 23.43 9.93" />
                                            </svg>
                                        </div>
                                        <span className="text-gray-600 text-lg">Afficher Tous</span>
                                    </label>
                                </div>
                                {errors.recipients && <p className="mt-1 text-red-500 text-sm">{errors.recipients}</p>}
                            </div>

                            {/* Corps du mail */}
                            <div>
                                <label className="block font-semibold text-gray-700">Corps du Mail</label>
                                <textarea
                                    name="body"
                                    value={emailData.body}
                                    onChange={(e) => setEmailData({ ...emailData, body: e.target.value })}
                                    className={`mt-1 p-2 border ${errors.body ? 'border-red-500' : 'border-gray-300'} rounded-md w-full`}
                                    placeholder="Écrivez votre message ici"
                                    rows="4"
                                />
                                {errors.body && <p className="mt-1 text-red-500 text-sm">{errors.body}</p>}
                            </div>

                            {/* Pièces jointes */}
                            <div className="mt-4">
                                <label className="block font-semibold text-gray-700">Pièces jointes</label>
                                <div className="flex flex-row flex-wrap gap-2 mt-2">
                                    {emailData.files.length > 0 ? (
                                        emailData.files.map((file, index) => (
                                            <div key={index} className="group relative flex justify-between items-center px-4 py-2 border-2 rounded-lg w-auto e-filemanager">
                                                <div className={`mr-2 w-5 h-5 e-list-icon e-fe-unknown ${file.icon}`}></div>
                                                <p className="text-gray-700">{file.name}</p>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const updatedFiles = emailData.files.filter((_, i) => i !== index);
                                                        setEmailData((prevData) => ({ ...prevData, files: updatedFiles }));
                                                    }}
                                                    className="-top-1.5 -right-1.5 absolute bg-red-500 opacity-0 group-hover:opacity-100 rounded-xl w-3 h-3 transition duration-100 ease-in"
                                                >
                                                    <span className="-top-0.5 right-[2.5px] absolute text-white text-xs">×</span>
                                                </button>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-gray-500 text-sm">Aucune pièce jointe sélectionnée</p>
                                    )}
                                </div>
                            </div>

                            <label class="flex justify-center gap-2 w-full mcui-checkbox">
                                <input
                                    type="checkbox"
                                    checked={IsCopyEmail}
                                    onChange={() => setIsCopyEmail(!IsCopyEmail)}
                                />
                                <div>
                                    <svg class="mcui-check" viewBox="-2 -2 35 35" aria-hidden="true">
                                        <polyline points="7.57 15.87 12.62 21.07 23.43 9.93" />
                                    </svg>
                                </div>
                                <span className="text-gray-600 text-lg">Je veux être en copie sur l'email de mon compte</span>
                            </label>

                            <div className="mt-4">
                                <button
                                    type="button"
                                    onClick={handleSendEmail}
                                    className="flex justify-center bg-orange-500 hover:bg-orange-600 shadow-lg my-5 p-4 rounded-full focus:shadow-outline focus:outline-none w-full font-semibold text-gray-100 tracking-wide transition duration-300 ease-in cursor-pointer"
                                >
                                    Envoyer l'Email
                                </button>
                            </div>

                            <div className="mt-3 text-center">
                                <button
                                    type="button"
                                    onClick={() => setIsEmailModalOpen(false)}
                                    className="text-gray-500 text-sm hover:underline"
                                >
                                    Annuler
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default FileManager;
